import React, { useEffect, useState } from 'react'
import FormattedMessage from '../../helpers/FormattedMessage'
import styles from './CustomInput.module.scss'

interface IProps {
  title: string
  placeholder: string
  onChange: (value: string) => void
  value: string
  type?: string
}

export const CustomInput = ({
  title,
  value,
  onChange,
  placeholder,
  type,
}: IProps) => {
  const [state, setState] = useState(value)

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState(e.target.value)
    onChange(e.target.value)
  }

  useEffect(()=>{
    setState(value)
  }, [value])

  return (
    <div className={styles.Wrapper}>
      <div className={styles.FormItem}>
        <div className={styles.InfoContainer}>
          <h4 className={styles.Title}>
            <FormattedMessage id={title}/>
          </h4>
          <input
            type={type ? type : 'number'}
            value={type ? state : Number(state) >= 0 ? state : ''}
            placeholder={placeholder}
            onChange={onInputChange}
          />
        </div>
      </div>
    </div>
  )
}
